export const getPapers = (state) => state.papers